import { useMutation } from "urql";

import { UpdateEmployeeCandidateDocument } from "../../../graphql/generated.ts";

export const useUpdateEmployeeCandidateRequest = () =>
  useMutation(UpdateEmployeeCandidateDocument);
